// auth.service.ts
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from './app/environments/environment';

export interface UserInfo {
    name: string;
    email?: string;
    roles?: string[];
}

@Injectable({ providedIn: 'root' })
export class AuthService {
    private user$ = new BehaviorSubject<UserInfo | null>(null);
    private bffBaseUrl = environment.apiUrlBase;

    constructor(private http: HttpClient) {}

    loadUser(): Observable<UserInfo> {
        const obs = this.http.get<UserInfo>(
            `${environment.apiUrl}/api/auth/me`,
            { withCredentials: true }
        );
        obs.subscribe({
            next: (u) => this.user$.next(u),
            error: () => this.user$.next(null),
        });
        return obs;
    }

    getUser() {
        return this.user$.asObservable();
    }

    startLogin() {
        const returnUrl = window.location.href;
        window.location.assign(
            `${this.bffBaseUrl}/login?returnUrl=${encodeURIComponent(
                returnUrl
            )}`
        );
    }

    startLogout() {
        const returnUrl = `${window.location.origin}/`;
        window.location.assign(
            `${this.bffBaseUrl}/logout?returnUrl=${encodeURIComponent(
                returnUrl
            )}`
        );
    }

    handleAccessDenied() {
        this.startLogin();
    }
}
